module.exports = __webpack_public_path__ + "img/print_without_pictures_blue.ffb0910d.svg";